import React from 'react';
import { StyleSheet, Text, View, Image, Dimensions, Modal, TextInput } from 'react-native';
import { useState, useRef } from 'react';
import Carousel from 'react-native-x-carousel';
import { NumberField } from '@base-ui/react/number-field';

import { styled } from '@mui/material/styles';
import ALLCARDS from './CardData.js';
import COVERCARD from './CoverCard.js';
import CardView from './CardView.js';
import 'react-modern-drawer/dist/index.css'

import './styles.css';

import { Global } from '@emotion/react';
import { Autocomplete, Button, ButtonGroup, Container, Grid, TextField, Box, Select, InputLabel, FormControl, MenuItem, SwipeableDrawer } from '@mui/material';


let ScreenHeight = Dimensions.get('window').height * .86;
let ScreenWidth = Dimensions.get('window').width * .86;
const w = Dimensions.get('window');
const drawerBleeding = 56;

function getRandom(arr, n) {
  var result = new Array(n),
    len = arr.length,
    taken = new Array(len);
  console.log('result ', result);
  if (n > len)
    throw new RangeError("getRandom: more elements taken than available");
  while (n--) {
    var x = Math.floor(Math.random() * len);
    result[n] = arr[x in taken ? taken[x] : x];
    taken[x] = --len in taken ? taken[len] : len;
  }
  return result;
}



function App() {

  const resetArrayLength = ALLCARDS.length - 1;
  const [isVisible, setIsVisible] = useState(false);
  const [modalInfo, setMoadalInfo] = useState(false);
  const [workingArray, setWorkingArray] = useState(COVERCARD);
  const [numSelected, setNumSelected] = useState(1);
  const [pressed, setPressed] = useState(false);
  const [cardListInputValue, setCardListInputValue] = useState("");
  const [shuffleNumber, setShuffleNumber] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  }
  const portrait = window.matchMedia("(orientation: portrait)");

  const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

  const [isPortrait, setIsPortrait] = useState(false);

  const handleChange = event => {

    var value = event.target.value;
    if (value != "") {

      if (value > ALLCARDS.length) {
        value = ALLCARDS.length
      }
      if (value < 1) { value = 1 }
      setShuffleNumber(value);
    }


  };

  const shuffle = () => {

    setWorkingArray(getRandom(ALLCARDS, shuffleNumber));
    if (shuffleNumber) {
      toggleDrawer();
    }


  };
  const clear = () => {
    console.log("clear");
    setShuffleNumber("");
  };

  portrait.addEventListener("change", function (e) {
    if (e.matches) {
      setIsPortrait(true);
    } else {
      setIsPortrait(false);
    }
  });


  const renderItem = data => (
    <View key={data.image} style={styles.cardContainer} >
      <CardView data={data} />
    </View>
  );
  const Puller = styled(Box)(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: '#ccc',
    borderRadius: 3,
    position: 'absolute',
    transform: 'rotate(-90deg)',
    top: ' calc(50% - 3px)',
    left: 0,
  }));


  return (

    <View style={styles.container}>
      <Global
        styles={{
          '.MuiDrawer-root > .MuiPaper-root': {
            width: `calc(90% - ${drawerBleeding}px)`,
            overflow: 'visible',
          },
        }}
      />

      <SwipeableDrawer
        disableBackdropTransition={!iOS} disableDiscovery={iOS}
        anchor="right"
        open={isOpen}
        PaperProps={{
          sx: { width: "90%" },
        }}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true
        }}
      >

        <View style={styles.drawerPanel}>
         <Puller sx={{ display: { xs: 'block', sm: 'none' } }} >   </Puller>

          <FormControl style={styles.buttonPanel}>

            <Autocomplete
              onInputChange={(event, newCardListInputValue) => {
                setCardListInputValue(newCardListInputValue);
              }}
              autoHighlight
              blurOnSelect='touch'
              id="card-dropdown"
              options={ALLCARDS}
              key={isOpen} //rerenders the component on every drawer opening to clear stale values
              getOptionLabel={(option) => [`${option.cardName} // ${option.songTitle}`].toString()}
              sx={{ width: '100%' }}
              inputValue={cardListInputValue}
              onChange={(event, newValue) => {
                if (newValue) {
                  setWorkingArray([newValue]);
                  toggleDrawer();
                }
              }}
              renderOption={(props, option) => (
                <Grid container spacing={{ xs: 0, sm: 2 }} direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  {...props}>
                  <Grid sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', padding: 0 }} item>
                    <img
                      loading="lazy"
                      height="45vh"
                      src={`${option.image}`}
                    />
                  </Grid>
                  <Grid item >
                    <strong>{option.cardName}</strong>
                  </Grid>
                  <Grid item sx={{ display: { xs: 'none', sm: 'flex' } }}> by {option.artist} </Grid>
                  <Grid item sx={{ display: { xs: 'flex', sm: 'none' } }}>//</Grid>
                  <Grid item > <em>{option.songTitle}</em></Grid>
                </Grid>
              )}
              renderInput={(params) => <TextField {...params} label="Search by card or song name" />}
            />

          </FormControl>

            {/*   
     <Button
        sx={{marginTop:"10px"}}
        onClick={()=>{
          setWorkingArray(getRandom(ALLCARDS, ALLCARDS.length)) ;
          toggleDrawer();
        }} 
        size="small" 
        variant="contained">Random Shuffle through all cards</Button>
     <Button       

      display="flex"
       alignItems="center"
        variant="contained"
        >
        <label htmlFor="numInput" >How many cards to shuffle? </label>
    <NumberField.Root 
        id = "numInput"        
        min={1}
        default={2}
        max={ALLCARDS.length}
        onValueCommitted={(value)=>{ 
          setWorkingArray(getRandom(ALLCARDS, value ));
          toggleDrawer();
          
        }} 
      >
        <NumberField.Input/>

      </NumberField.Root>

      </Button> */}
          <Box
            my={1}
            display="flex"
            alignItems="center"
            gap={4}
            p={2}
          >
            <TextField
              id="outlined-number"
              label={"Draw how many? (1-" + ALLCARDS.length + ")"}
              value={shuffleNumber}
              type="number"

              onChange={handleChange}
            >
            </TextField>
          </Box>

          <Box
            my={0}
            display="flex"
            alignItems="center"
            gap={4}
            p={2}
          >
            <ButtonGroup >

              <Button
                onClick={shuffle}>Shuffle!</Button>

              <Button
                onClick={clear}>Clear</Button>


            </ButtonGroup>
          </Box>


          <Box

            my={4}
            display="flex"
            alignItems="center"
            gap={2}
            p={2}
          >
            <Button
              sx={{ marginTop: "10px" }}
              onClick={() => {
                setWorkingArray(COVERCARD);
                toggleDrawer();
              }}
              size="small"
            >Return to opening screen</Button>
          </Box>

        </View>

      </SwipeableDrawer>

      <Modal
        animationType={'slide'}
        onRequestClose={() => setIsVisible(false)}
        visible={isVisible}
      >

      </Modal>

      <Carousel
        data={workingArray}
        renderItem={renderItem}
        loop
      />

      <Button size="small" onClick={toggleDrawer} variant="contained">Menu</Button>

    </View>


  );
};


const styles = StyleSheet.create({
  drawerPanel: {
    height: '100%',
    left: -30,
    paddingLeft: 30,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    visibility: 'visible',
  },
  cardContainer: {

    border: '1px solid red'
  },
  container: {
    position: 'relative',
    height: '85vh',
    width: '90vw',

    aspectRatio: 299 / 499,
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  carouselBox: {
    border: '1px solid pink',

  },
  infoBtn: {
    position: 'absolute',
    bottom: '-10px',
    backgroundColor: 'rgba(174, 231, 255, 0.3)',
  },
  buttonPanel: {
    paddingTop: 20,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: 10,
  },
  paneHeading: {
    marginTop: '20px',
    fontStyle: 'italic',
    fontWeight: 'bold'
  },
  infoPane: {
    marginRight: '2em',
    marginLeft: '2em',
    alignItems: 'stretch',
    justifyContent: 'center',
    flex: 1,

  },
  cardName: {
    fontSize: '2em',
    fontWeight: 'bold',
    marginBottom: 20,
  },
  cardDesc: {
    fontSize: '.9em',
  },
  cardMeaning: {
    margin: 20,
    fontStyle: 'italic',
  },
  cardSongTitle: {
    fontSize: '1em',
    fontWeight: 'bold',
    fontStyle: 'italic',
  },
  cardArtist: {

    fontSize: '1em',

  },

  cardContainer: {
    // alignItems: 'center',
    // justifyContent: 'center',
    // ScreenWidth,
  },
  cardWrapper: {
    borderRadius: 8,
    overflow: 'hidden',
    margin: 10,
  },
  card: {
    // width: ScreenWidth ,
    // height: ScreenHeight,
  },
  cornerLabel: {
    position: 'absolute',
    top: 0,
    left: 0,
    borderTopLeftRadius: 8,

  },
  cornerLabelText: {
    fontSize: 12,
    color: '#fff',
    fontWeight: '600',
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 2,
    paddingBottom: 2,
  },

});

export default App;
